import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaRupeeSign, FaCheckCircle } from "react-icons/fa";
import ConfettiExplosion from "./ConfettiExplosion";

const SanctionCompletedModal = ({ show, onClose, handleSanctionModalClose }) => {
  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/25 backdrop-blur-sm z-50"
        onClick={onClose}
      />

      <ConfettiExplosion />

      <div className="fixed inset-0 z-[70] flex items-center justify-center pointer-events-none p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 40 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.85, y: 40 }}
          transition={{ duration: 0.45, type: "spring", bounce: 0.35 }}
          className="w-full max-w-[480px] pointer-events-auto"
        >
          <div className="relative overflow-hidden rounded-3xl border border-gray-200/80 bg-white/95 backdrop-blur-xl shadow-2xl shadow-[#FF6B35]/15">
          {/* <button
            onClick={onClose}
            aria-label="Close sanction modal"
            className="absolute rounded-full top-4 w-10 h-10 right-4 text-white hover:text-gray-800 transition-colors z-20"
          >
            ✕
          </button> */}

          <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35]/08 via-transparent to-[#1E3A8A]/08" />
          <motion.div
            className="absolute inset-0 opacity-60"
            style={{
              background:
                "linear-gradient(140deg, rgba(255,107,53,0.12), rgba(230,90,43,0.12), rgba(30,58,138,0.12))",
              backgroundSize: "400% 400%",
            }}
            animate={{ backgroundPosition: ["0% 0%", "100% 100%", "0% 0%"] }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          />

          <div className="relative z-10 px-6 sm:px-8 py-8 sm:py-10 text-center space-y-6">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", bounce: 0.45 }}
              className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#FF6B35] shadow-[0_15px_45px_rgba(255,107,53,0.35)]"
            >
              <FaCheckCircle className="h-8 w-8 text-white" />
            </motion.div>

            <div className="space-y-2">
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.35, type: "spring", bounce: 0.3 }}
                className="text-sm text-gray-600"
              >
                Your Snap Paisa application has reached the best part.
              </motion.p>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.45, type: "spring", bounce: 0.4 }}
                className="text-2xl sm:text-3xl font-bold text-[#FF6B35]"
              >
                Loan Sanctioned!
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6, type: "spring", bounce: 0.3 }}
                className="text-sm sm:text-base text-gray-600 leading-relaxed"
              >
                Complete the final disbursal step to see your funds land in your account.
              </motion.p>
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.75, type: "spring", bounce: 0.4 }}
              className="flex items-center justify-center gap-3 text-xs sm:text-sm text-gray-600"
            >
              <div className="flex items-center gap-2">
                <div className="flex h-7 w-7 items-center justify-center rounded-full bg-[#FF69B4]/20 border border-[#FF69B4]/50 text-[#C73E6B]">
                  <FaCheckCircle className="h-3.5 w-3.5" />
                </div>
                <span>Sanctioned</span>
              </div>
              <div className="h-px w-12 bg-gradient-to-r from-transparent via-gray-300 to-transparent" />
              <div className="flex items-center gap-2">
                <div className="flex h-7 w-7 items-center justify-center rounded-full bg-[#00CED1]/20 border border-[#00CED1]/50 text-[#0891B2]">
                  <span className="text-xs font-semibold">2</span>
                </div>
                <span>Disbursal</span>
              </div>
            </motion.div>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, type: "spring", bounce: 0.35 }}
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              onClick={handleSanctionModalClose}
              className="mx-auto flex items-center justify-center gap-2 rounded-full bg-[#FF6B35] px-6 py-3 text-sm sm:text-base font-semibold text-white shadow-lg shadow-[#FF6B35]/30 transition-all"
            >
              <span>Proceed to disbursal</span>
              <FaRupeeSign className="h-5 w-5" />
            </motion.button>
          </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default SanctionCompletedModal;
